var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1547 3.48822L12.512 5.84555M11.1547 2.48822C11.4673 2.17562 11.8912 2 12.3333 2C12.7754 2 13.1994 2.17562 13.512 2.48822C13.8246 2.80082 14.0002 3.2248 14.0002 3.66689C14.0002 4.10897 13.8246 4.53295 13.512 4.84555L4.33333 14.0242H2V11.6429L11.1547 2.48822Z",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/IconEdit.edb199559e7e35dfdc4a6d909d9b884e.svg";
export { ForwardRef as ReactComponent };